export const RESOURCE_REF_PROP = 'resource.ref';
export const PROFILE_PROP = 'profile';
